import { Card, Stack, Typography } from '@mui/material'
import { C1DrawerInner } from 'components/core/drawer/C1DrawerInner'
import { AppEntitlements } from 'components/pages/app/details/tabs/app-entitlements'
import { AppUserDisplayNameWithFetch } from 'components/pages/app/users/app-user-display-name'
import { AppResourceTypeTraits } from 'lib/constants/app'
import { FormattedMessage } from 'react-intl'

type AppUserRolesTableProps = {
    appId: string
    appUserId: string
}

export const AppUserRolesTable = ({
    appId,
    appUserId,
}: AppUserRolesTableProps): React.ReactElement => {
    return <C1DrawerInner>
        <C1DrawerInner.Header>
            <Stack spacing={4}>
                <Typography variant="h4" component="div">
                    <FormattedMessage
                        defaultMessage="Roles"
                        id="components_app_user_roles_table_header"
                    />
                </Typography>
                <Card variant="outlined" sx={{ p: 2 }}>
                    <AppUserDisplayNameWithFetch appId={appId} id={appUserId} />
                </Card>
            </Stack>
        </C1DrawerInner.Header>
        <C1DrawerInner.Content>
            <AppEntitlements
                appId={appId}
                appUserId={appUserId}
                resourceTraitIds={[AppResourceTypeTraits.role]}
                hiddenFilters={['resourceType']}
            />
        </C1DrawerInner.Content>
    </C1DrawerInner>
}
